import request from '@/utils/request'

// 查询银河打本剧本申领列表
export function listScriptApply(query) {
  return request({
    url: '/played/script/apply/list',
    method: 'get',
    params: query
  })
}

// 查询银河打本剧本申领详细
export function getScriptApply(id) {
  return request({
    url: '/played/script/apply/' + id,
    method: 'get'
  })
}

// 新增银河打本剧本申领
export function addScriptApply(data) {
  return request({
    url: '/played/script/apply',
    method: 'post',
    data: data
  })
}

// 修改银河打本剧本申领
export function updateScriptApply(data) {
  return request({
    url: '/played/script/apply',
    method: 'put',
    data: data
  })
}

// 删除银河打本剧本申领
export function delScriptApply(id) {
  return request({
    url: '/played/script/apply/' + id,
    method: 'delete'
  })
}

// 审核银河打本剧本申领状态
export function auditApplyStatus(data) {
  return request({
    url: '/played/script/apply/audit/status',
    method: 'post',
    data: data
  })
}

// 银河打本申领任务-确认发货
export function confirmShipment(data) {
  return request({
    url: '/played/script/apply/confirm/shipment',
    method: 'post',
    data: data
  })
}
